import profileImage from "./images/profileImage.png";
import myProfile from "./images/myProfile.png";
import profile from "./images/profile.png";
import rightImage from "./images/right-image.png";
import watermark from './images/watermark.png';
import oops from './images/oops.png';
import debit from './images/debit-card.svg';
export default {
  profile,
  profileImage,
  myProfile,
  rightImage, 
  watermark,
  oops,
  debit
};
